export default __webpack_public_path__ + "static/media/filepreview.d82f4f8b.png";